"use strict";
var pinBoxes = document.querySelectorAll(".bcontainer > *");
var pinWrap = document.querySelector(".bcontainer");
var pinWrapWidth = pinWrap.offsetWidth;
var horizontalScrollLength = pinWrapWidth - window.innerWidth;
// Pinning and horizontal scrolling
gsap.to(".bcontainer", {
    scrollTrigger: {
        scrub: true,
        trigger: "#sectionPin",
        pin: true,
        // anticipatePin: 1,
        start: "top top",
        end: pinWrapWidth,
        snap: 0.33
    },
    x: -horizontalScrollLength,
    ease: "none"
});
